import { Card, Text } from '@change/ds-core-ui/next';

import type { NormalizedDecisionMaker } from '../../../../shared/types';
import { AvatarAndBadge } from '../../../shared/AvatarAndBadge';
import { DecisionMakerResponse } from '../../../shared/DecisionMakerResponse';
import { Location } from '../../../shared/Location';
import { Name } from '../../../shared/Name';
import { ResponseBadge } from '../../../shared/ResponseBadge';
import { SignersText } from '../../../shared/SignersText';

export const DecisionMakerCardDesktop: React.FC<{ dm: NormalizedDecisionMaker }> = ({
	dm: { displayName, id, location, title, photoUrl, publiclyVisible, signersText, slug, response, type },
}) => {
	const heading = title ? `${displayName},` : displayName;

	return (
		<Card className="mb-6 hidden bg-white p-6 shadow-md lg:block">
			<div className="flex gap-4">
				<div>
					<AvatarAndBadge displayName={displayName} photoUrl={photoUrl} showDMIcon={type === 'POLITICIAN'} />
				</div>

				<div className="w-full">
					<div className="flex w-full flex-col xl:flex-row">
						<div className="w-full">
							<div className="mr-1 flex w-full">
								<div className="flex flex-wrap items-center gap-2">
									<Name displayName={heading} id={id} publiclyVisible={publiclyVisible} slug={slug} />
									{title && (
										<Text variant="heading" size="small" fontWeight="light">
											{title}
										</Text>
									)}
								</div>

								<div className="ml-auto flex-shrink-0">
									<ResponseBadge response={response} />
								</div>
							</div>
						</div>
					</div>

					<div className="mb-4 mt-1 flex min-h-5">
						{location && <Location location={location} />}
						{signersText && <SignersText signersText={signersText} />}
					</div>

					{response && <DecisionMakerResponse response={response} />}
				</div>
			</div>
		</Card>
	);
};
